import { render, staticRenderFns } from "./elastic-product-filters.vue?vue&type=template&id=a7bbbd06"
import script from "./elastic-product-filters.vue?vue&type=script&lang=js"
export * from "./elastic-product-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports